import * as React from 'react';
export var directionEnum;
(function (directionEnum) {
  directionEnum["RTL"] = "RTL";
  directionEnum["rtl"] = "RTL";
  directionEnum["LTR"] = "LTR";
  directionEnum["ltr"] = "LTR";
})(directionEnum || (directionEnum = {}));
var defaultPrefixCls = 'roo';
export var DirectionContext = /*#__PURE__*/React.createContext('LTR');
export var PrefixClsContext = /*#__PURE__*/React.createContext(defaultPrefixCls);
export var SizeContext = /*#__PURE__*/React.createContext(undefined);
export var GlobalConfigContext = /*#__PURE__*/React.createContext({
  direction: 'LTR',
  prefixCls: defaultPrefixCls
});
var globalHolderRender;
var globalPrefixCls;
var setGlobalConfig = function setGlobalConfig(props) {
  if (props.prefixCls) {
    globalPrefixCls = props.prefixCls;
  }
  if (props.holderRender) {
    globalHolderRender = props.holderRender;
  }
};
// export const ConfigProvider: React.FC<ConfigContextProps> = ({ config, children }) => {
export var ConfigProvider = function ConfigProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  var _a;
  var originDisabled = React.useContext(DirectionContext);
  var originPrefixCls = React.useContext(PrefixClsContext);
  // const size = React.useContext(SizeContext);
  var prefixClsValue = (_a = config === null || config === void 0 ? void 0 : config.prefixCls) !== null && _a !== void 0 ? _a : defaultPrefixCls;
  var directionOnChange = React.useCallback(function () {
    if ((config === null || config === void 0 ? void 0 : config.direction) === 'RTL' || (config === null || config === void 0 ? void 0 : config.direction) === 'rtl') {
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.setAttribute('class', "".concat(prefixClsValue, "-rtl"));
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.setAttribute('class', '');
    }
  }, [config === null || config === void 0 ? void 0 : config.direction]);
  React.useEffect(function () {
    directionOnChange();
  }, [config === null || config === void 0 ? void 0 : config.direction]);
  var directionValue = directionEnum[config === null || config === void 0 ? void 0 : config.direction];
  return /*#__PURE__*/React.createElement(GlobalConfigContext.Provider, {
    value: {
      direction: directionValue || originDisabled,
      prefixCls: prefixClsValue || originPrefixCls,
      size: config === null || config === void 0 ? void 0 : config.size
    }
  }, children);
};
export var globalConfig = function globalConfig() {
  return {
    prefixCls: globalPrefixCls,
    holderRender: globalHolderRender
  };
};
ConfigProvider.GlobalConfigContext = GlobalConfigContext;
ConfigProvider.config = setGlobalConfig;
export default ConfigProvider;